import { render, staticRenderFns } from "./login copy.vue?vue&type=template&id=5d254fe6&scoped=true&"
import script from "./login copy.vue?vue&type=script&lang=js&"
export * from "./login copy.vue?vue&type=script&lang=js&"
import style0 from "./login copy.vue?vue&type=style&index=0&id=5d254fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d254fe6",
  null
  
)

export default component.exports